__turbopack_context__.v({
  "badges": "_8q2nlW_badges",
  "metadata": "_8q2nlW_metadata",
  "salt": "_8q2nlW_salt",
  "saltExplanation": "_8q2nlW_saltExplanation",
  "saltNumber": "_8q2nlW_saltNumber",
  "saltScale": "_8q2nlW_saltScale",
  "saltScore": "_8q2nlW_saltScore",
  "saltTier": "_8q2nlW_saltTier",
  "saltValue": "_8q2nlW_saltValue",
  "saltVote": "_8q2nlW_saltVote",
  "saltVotes": "_8q2nlW_saltVotes",
  "tile": "_8q2nlW_tile",
  "tileCaption": "_8q2nlW_tileCaption",
  "tileLabel": "_8q2nlW_tileLabel",
  "tileLink": "_8q2nlW_tileLink",
  "tileValue": "_8q2nlW_tileValue",
  "tiles": "_8q2nlW_tiles",
  "tooFewVotes": "_8q2nlW_tooFewVotes",
});
